"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtworkCaption = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

var _react = _interopRequireDefault(require("react"));

var _palette = require("@artsy/palette");

var _ArtworkCaption = require("../ArtworkCaption");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ArtworkCaption = function ArtworkCaption(_ref) {
  var section = _ref.section,
      rest = _objectWithoutProperties(_ref, ["section"]);

  return _react.default.createElement(_palette.Box, rest, _react.default.createElement(_ArtworkCaption.ArtworkCaption, {
    flex: "1",
    artwork: section,
    isFullscreenCaption: true,
    linked: true,
    color: "black100"
  }), _react.default.createElement(_palette.Button, {
    variant: "secondaryGray" // TODO: event should be the correct type in palette
    ,
    onClick: function onClick(event) {
      // TODO: This isn't a real link and that's annoying
      // <Button> doesn't support `as`, once it does, replace
      // click handler this with: as={RouterLink} to={`/artwork/${section.slug}`}
      var path = "/artwork/".concat(section.slug);

      if (event.metaKey) {
        window.open(path, "_blank");
        return;
      }

      window.location.href = path;
    }
  }, "View"));
};

exports.ArtworkCaption = ArtworkCaption;
//# sourceMappingURL=ArtworkCaption.js.map